module.exports = __webpack_public_path__ + "media/images/smart_phone/products/nikuman2-049ac46ee27a7a2d44e884afa0fd67b1.jpeg";